import GPT from "../gpt/GPT";
import FallbackAd from "../taglessAd/FallbackAd";
import TaglessAd from "../taglessAd/TaglessAd";
import Ad from "../gpt/Ad";

/**
 * Always render ad
 */

export default class AlwaysRenderRenderingStrategy {

    _gpt: GPT;
    _gamTagless: TaglessAd;
    _isTaglessAdEnabled: boolean;
    _services: string[];
    _fallbackAd: FallbackAd;
    _showFallbackAds: boolean;

    constructor(
        gpt: GPT,
        gamTagless: TaglessAd,
        isTaglessAdEnabled: boolean,
        fallbackAd: FallbackAd,
        showFallbackAds: boolean
    ) {
        this._gpt = gpt;
        this._gamTagless = gamTagless;
        this._isTaglessAdEnabled = isTaglessAdEnabled;
        this._services = [gpt.services.pubads];
        this._fallbackAd = fallbackAd;
        this._showFallbackAds = showFallbackAds;
    }

    /**
     * Add the ad to the set of unrendered ads and start the state machine
     */
    render(ad: Ad) {
        const containerId = ad.getContainerId();

        if (ad.isDisplayable()) {
            if (this._showFallbackAds) {
                this._fallbackAd.render(ad);
            } else if (this._isTaglessAdEnabled && containerId.includes("leaderboard")) {
                this._gamTagless.render(ad);
            } else {
                this._gpt.render(ad, { services: this._services });
            }
        }
    }

    /**
     * Refreshes the list of ads immediately
     */
    refresh(ads: Ad[]) {
        this._gpt.refresh(ads);
    }

    setFallbackFlag(flag: boolean) {
        this._showFallbackAds = flag;
    }

}
